module.exports = __webpack_public_path__ + "img/kuaishou_qr.283edd15.jpg";